<div class="modal-inner">
    @if (form) {
        <div class="modal-inner-inner">
            <h1>Wijzig projectnummer</h1>
            <input [formControl]="fcProjectSearch" placeholder="Zoeken in projecten" />
            <div class="results">
                @if (searching) {
                    <div class="result text-center">aan het zoeken...</div>
                } @else if (projects?.length === 0) {
                    <div class="result text-center">
                        {{ fcProjectSearch.value?.length > 0 ? 'project niet gevonden' : 'voer een projectnummer in' }}
                    </div>
                }
                @for (project of projects; track project) {
                    <div
                        class="result"
                        [class.active]="project.projectId === form.controls.projectId.value"
                        (click)="selectProject(project.projectId, project.planningId)">
                        <strong>{{ project.projectId }}</strong> {{ project.location }}
                        @if (project.projectId === form.controls.projectId.value) {
                            (huidig)
                        }
                    </div>
                }
            </div>
        </div>
    }

    <div class="buttons">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
</div>
